"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = void 0;

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var grid_1 = require("antd/es/grid");

var layout_1 = tslib_1.__importDefault(require("antd/es/layout"));

var __1 = require("..");

exports.Header = function (_ref) {
  var leftSlot = _ref.leftSlot,
      rightSlot = _ref.rightSlot;
  return React.createElement(layout_1["default"].Header, {
    className: 'clp-header'
  }, React.createElement(__1.Container, null, React.createElement(grid_1.Row, null, React.createElement(grid_1.Col, {
    xl: 6,
    lg: 8,
    md: 10,
    xs: 16
  }, leftSlot), React.createElement(grid_1.Col, {
    xl: 18,
    lg: 16,
    md: 14,
    xs: 8
  }, rightSlot))));
};